<template>
    <div :class="['page-view', {loaded: !loading}]">
        <h1 class="red-title">404</h1>
        <div class="red">
            <div class="content">
                <h1 class="white-title">404</h1>
                <p class="descripion">
                    {{$t('common.pagenotfound')}}
                </p>
                <Cta
                    :type="'router-link'"
                    :to="$trl({
                        name: 'Home',
                        params: {
                            locale: $route.params.locale
                        }
                    })"
                    :colors="{
                        default: { color: '#636776', background: '#FFFFFF' },
                        hover:   { color: '#FFFFFF', background: '#114991' }
                    }"
                    class="link"
                >
                    {{$t('cta.backtohome')}}
                </Cta>
            </div>
        </div>
    </div>
</template>
<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    data() {
        return {
            loading: false
        }
    },
    created() {
        const event = new CustomEvent('papillon')
        event.status = 404
        window.dispatchEvent(event)
        try { window.dispatchEvent(new Event('papillon')) } catch(e) {}
        this.$nextTick(() => {
            this.loading = false
            window.scroll(0, 0)
        })
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
h1
    font-size: 300px
    color: #ff2b2a
    font-weight: 500
    letter-spacing: -0.03125em
.red
    position: absolute
    top: 50%
    left: 0
    right: 0
    bottom: 0
    background: #ff2b2a
    overflow: hidden
    text-align: center
.content
    display: inline-block
    text-align: left
.red-title
    position: absolute
    top: 50%
    left: 50%
    transform: translateY(-50%) translateX(-50%)
.white-title
    margin: 0 0 160px
    color: #FFF
    line-height: 0
.descripion
    font-size: 50px
    font-weight: 500
    color: #ffffff
    margin-bottom: 70px
</style>
